/*----------------------------------------------------------------------------
    The following JavaScript functions are for showing a quick display dialog
------------------------------------------------------------------------------*/

// Shows the quick display, and allows for the text and duration to display in milliseconds
function ShowQuickDisplayDialog( infoText, duration ) {
    $("#quickDisplayDlg").find(".infoText").html(infoText);
    $("#quickDisplayDlg").modal("show");
    
    // Wait a set amount of time till the dialog is closed
    setTimeout(HideQuickDisplayDialog, duration);
}

// Hides the quick display dialog
function HideQuickDisplayDialog() {
    $("#quickDisplayDlg").modal("hide");
}

/*----------------------------------------------------------------
    The following JavaScript functions are for handle key presses
------------------------------------------------------------------*/

//Clicks the given button if the given key press is enter
function ClickButtonForEnterKey(keyPressEvent, buttonId) {

    var button = document.getElementById(buttonId);

    if (KeyPressIsEnter(keyPressEvent) && button != null) {

        button.click();
    }
}

//Metho used to determine if the given key press is enter
function KeyPressIsEnter(keyPressEvent) {

    if (keyPressEvent.keyCode === 13) {

        keyPressEvent.preventDefault(); // Ensure it is only this code that runs
        return true;
    }
    return false;
}

/*---------------------------------------------------------------------------------
 The following JavaScript functions are to make calling server side methods easier
-----------------------------------------------------------------------------------*/

function CallServer(serverArgs) {

    if (serverArgs) {

        // Set defaults
        serverArgs.action = serverArgs.action || "";
        serverArgs.controller = serverArgs.controller || "";
        serverArgs.url = serverArgs.url || serverArgs.controller + "/" + serverArgs.action;
        serverArgs.key = serverArgs.key || null;
        serverArgs.data = serverArgs.data || null;
        serverArgs.showError = (serverArgs.showError === undefined) ? false : serverArgs.showError;
        serverArgs.contentType = serverArgs.contentType || "application/x-www-form-urlencoded; charset=UTF-8";
        serverArgs.beforeSend = serverArgs.beforeSend || null;
        serverArgs.error = serverArgs.error || null;
        serverArgs.success = serverArgs.success || null;
        serverArgs.responseProgress = serverArgs.responseProgress || null;
        serverArgs.requestProgress = serverArgs.requestProgress || null;
        serverArgs.genericSaveResultError = serverArgs.genericSaveResultError || false;
        serverArgs.dataType = serverArgs.dataType || null;

        if ( serverArgs.data ) {
            serverArgs.data["__RequestVerificationToken"] = document.querySelector( "meta[name=\"csrf-token\"]" ).getAttribute( "content" );
        }

        // Create a lock to prevent this server call being done multiple times before the first
        // call has completed
        var lockCreated;
        if (serverArgs.key) {
            lockCreated = AddLock(serverArgs.key);
        } else {
            // No lock key so do not bother creating trying to stop multiple calls
            lockCreated = true;
        }

        if (lockCreated) {
            $.ajax({
                url: baseSiteUrl + "umbraco/Surface/" + serverArgs.controller + "/" + serverArgs.action,
                type: "POST",
                data: serverArgs.data,
                contentType: serverArgs.contentType,
                dataType: serverArgs.dataType,
                beforeSend: function() {
                    // Event called before ajax call
                    if (typeof serverArgs.beforeSend === "function") {
                        serverArgs.beforeSend();
                    }
                },
                error: function(err) {
                    // Event called when an error occurs
                    ClearLock(serverArgs.key);

                    if (typeof serverArgs.error === "function") {
                        serverArgs.error(err);
                    }
                },
                success: function(result, textStatus, jqXhr) {
                    // Event called when the call is successful
                    ClearLock(serverArgs.key);

                    var runCallBack = false;

                    var unexError = jqXhr.getResponseHeader("Error");
                    if (unexError) {
                        // An unexpected error stored in the response header has occurred (this could be a permissions failure
                        // etc.). So display the error and do nothing else
                    } else {

                        if (serverArgs.genericSaveResultError) {
                            // Treat the result as a generic save result error and show the error message if it is in a failure state
                            if (result) {
                                if (result.Saved) {
                                    // Result has a success state so run the success call back
                                    runCallBack = true;
                                } else {
                                    // Process failed so show the error message
                                }
                            } else {
                                // No data returned so show a general error message
                            }
                        } else {
                            runCallBack = true;
                        }

                        if (runCallBack) {
                            if (typeof serverArgs.success === "function") {
                                serverArgs.success(result);
                            }
                        }
                    }
                }
            });
        }
    }
}

/*-------------------------------------------------------------------------------------------
    The following JavaScript functions are for locking operations to prevent double clicking
---------------------------------------------------------------------------------------------*/

// Attempt to add a lock to a key, if the key is already locked then return False, otherwise, add the lock and return True
function AddLock(key) {

    var lockCreated = false;

    if (key) {

        // Get the existing list of locks
        var locks;
        try {
            locks = JSON.parse($("#sysItemLocking").val());
        } catch (e) {
            locks = {};
        }

        if (locks && !locks[key]) {
            // This key has not been locked so add it to the list of locks and return true
            locks[key] = true;
            $("#sysItemLocking").val(JSON.stringify(locks));
            lockCreated = true;
        }
    }

    return lockCreated;
}

// Remove the lock for key
function ClearLock(key) {

    if (key) {
        // Get the existing list of locks
        var locks;
        try {
            locks = JSON.parse($("#sysItemLocking").val());
        } catch (e) {
            locks = {};
        }

        // Delete the lock if required
        if (locks && locks[key]) {
            delete locks[key];
            $("#sysItemLocking").val(JSON.stringify(locks));
        }
    }
}

/*-----------------------------------------------------------
 The following JavaScript functions control Validation
------------------------------------------------------------*/

var TECL_Validation = {

    // Check if the text is an email address
    ValidateEmailAddress: function(emailAddress) {
        var emailReg = /^([\w_+\-\.]+)@([\w_+\-\.]+)\.([\w-]{2,10})$/;
        var isEmailAddress = emailReg.test(emailAddress.trim());
        return isEmailAddress;
    }

};